import { Box, Button } from "@mantine/core";
import { ArrowLeftIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { Page, PageHeader } from "../../components/layout/Page";
import { ReturnDecisionView } from "../../components/returns/return-decision";
import classes from "../../components/returns/return-decision.module.css";

/** /refund-invoice/:id — жагсаалтын drawer-тай ижил агуулгыг хуудсаар харуулна. */
export const ReturnDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation("returns");

  return (
    <Page>
      <PageHeader
        title={t("decision.title")}
        extra={
          <Button variant="default" leftSection={<ArrowLeftIcon size={14} />} onClick={() => navigate("/refund-invoice")}>
            {t("decision.back")}
          </Button>
        }
      />
      <Box className={classes.pageWrap}>{id && <ReturnDecisionView id={id} mode="page" />}</Box>
    </Page>
  );
};
